import { CropCyclesPeriodSelectorEnum } from '../../enums/cropCyclePeriodSelectorEnum';

export class CropCyclesPeriodFilter {
  periodSelectorType: CropCyclesPeriodSelectorEnum;
  formattedPeriod: string;
  weekNumber?: number;
}
